import { KeyIcon } from "@/components/icons";
import { Eyebrow } from "@/components/Eyebrow";
import { SectionHeader } from "@/components/SectionHeader";
const BULLETS = [
  {
    eyebrow: "Business performance",
    title: "Improve profitability",
    body: "Increase revenue with premium scene-based lighting experiences.",
  },
  {
    eyebrow: "Operational efficiency",
    title: "Lower operating costs",
    body: "Optimize your maintenance team’s efficiency and solve issues before your guests notice.",
  },
  {
    eyebrow: "Energy efficiency",
    title: "Reduce energy usage",
    body: "Use occupancy and room conditions to reduce consumption and support sustainability goals.",
  },
  {
    eyebrow: "Asset protection",
    title: "Protect your property",
    body: "Monitor lighting, HVAC, humidity, smoke, water leaks, and other critical room conditions before small issues become big ones.",
  },
];

export function BusinessSection() {
  return (
    <section className="relative z-10 section-panel px-8 py-20 md:z-auto md:px-6 md:py-24 lg:py-32">
      <SectionHeader
        variant="centered"
        icon={<KeyIcon className="size-10 text-brand" />}
        title="The Key to Better Stays and Stronger Performance"
        body="Run your property with less cost, complexity, and waste. Our technology automates everyday operations, optimizes energy use, and monitors critical systems to help teams stay ahead of issues."
      />
      <ul className="mx-auto mt-12 grid max-w-8xl md:mt-16 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {BULLETS.map((bullet) => (
          <li
            key={bullet.title}
            className="flex flex-col justify-between gap-12 rounded-card bg-primary p-4 md:gap-4 md:px-8 md:py-6"
          >
            <Eyebrow tone="muted">{bullet.eyebrow}</Eyebrow>
            <div className="flex flex-col gap-6 text-primary md:gap-2">
              <h3 className="text-balance text-lg leading-title md:text-2xl md:leading-title">
                {bullet.title}
              </h3>
              <p className="text-sm leading-normal tracking-body md:text-base">
                {bullet.body}
              </p>
            </div>
          </li>
        ))}
      </ul>
      <span
        aria-hidden
        className="absolute -bottom-12 left-1/2 h-24 w-px -translate-x-1/2 bg-gradient-to-b from-transparent via-line-strong to-transparent md:hidden"
      />
    </section>
  );
}
